import React from 'react';
import { connect } from 'react-redux';

import LeftSideBarComponent from './LeftSideBarComponent';

class LeftSideBarContainer extends React.Component {
  render(){
    return(
      <LeftSideBarComponent
        {...this.props}
      />
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    vragen: state.questionElement,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      changeQuestionElement: dispatch.questionElement.changeQuestionElement,
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(LeftSideBarContainer);
